import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SiteContext = createContext({});

const COLOR_VARS = {
  primary_color: "--brand-primary",
  accent_color: "--brand-accent",
  text_color: "--brand-text",
  heading_color: "--brand-heading",
  link_color: "--brand-link",
  footer_bg_color: "--brand-footer-bg",
  footer_text_color: "--brand-footer-text",
};

const applyTheme = (s) => {
  const root = document.documentElement;
  Object.entries(COLOR_VARS).forEach(([k, v]) => {
    if (s?.[k]) root.style.setProperty(v, s[k]);
  });
};

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [loaded, setLoaded] = useState(false);
  const refresh = () =>
    api.get("/site/settings").then((r) => {
      setSettings(r.data);
      applyTheme(r.data);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  useEffect(() => { refresh(); }, []);
  return <SiteContext.Provider value={{ settings, loaded, refresh }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
